export default "__VITE_ASSET__309477af__$_?component__"